"use client"

import { useState, useEffect } from "react"
import {
  Box,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Alert,
  Snackbar,
} from "@mui/material"
import { ExpandMore as ExpandMoreIcon, Upload as UploadIcon } from "@mui/icons-material"
import DocumentCard from "./DocumentCard"
import SelfieUploadDialog from "./SelfieUploadDialog"
import ImageEditorDialog from "./ImageEditorDialog"
import { updateKYCInfo, uploadKYCDocs, uploadMerchantKYCDocs } from "../../../util/API/KYC_new"
import { useSelector } from "react-redux"
import PinPad from "../../PinPad/PinPad"
import { format, parseISO } from "date-fns";

const DocumentCategorySection = ({
  category,
  documents,
  onDocumentUpdate,
  onMarkExpired,
  onUploadNew,
  onStatusUpdate,
  countries,
  states,
  getStatesForCountry,
  expanded,
  onAccordionChange,
  userType = "user",
  subtypeLookup = {},
  documentImagesMap = {},
  getUserKycData,
  activeTab
}) => {
  const [editingDocId, setEditingDocId] = useState(null)
  const [uploadDialog, setUploadDialog] = useState(false)
  const [selfieDialog, setSelfieDialog] = useState(false)
  const [selectedSubType, setSelectedSubType] = useState("") // This will store the subtype name
  const [selectedSubTypeId, setSelectedSubTypeId] = useState("") // This will store the subtype ID
  const [isDragOver, setIsDragOver] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null)
  const [imageEditorDialog, setImageEditorDialog] = useState(false)
  const [imageToEdit, setImageToEdit] = useState(null)
  const [showPinPad, setShowPinPad] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [isStatusUpdating, setIsStatusUpdating] = useState(false);

  const [isUploading, setIsUploading] = useState(false)
  const [uploadProgress, setUploadProgress] = useState(0)
  const [notification, setNotification] = useState({ open: false, message: "", severity: "success" })
  let agent = JSON.parse(sessionStorage.getItem("user")).payload.body;
  let selectedUserData = useSelector(
    (state) => state.usersList.selectedUser
  );

  console.log("Testing123------------");

  useEffect(() => {
    // Pre-select selfie if it's the selfie category (check by name or id)
    const isSelfieCategory =
      category.name === "Selfie Verification" ||
      category.id === "1" ||
      category.subTypes.some((sub) => sub.name === "Selfie")

    if (isSelfieCategory && category.subTypes.some((sub) => sub.name === "Selfie")) {
      const selfieSubtype = category.subTypes.find((sub) => sub.name === "Selfie")
      setSelectedSubType("Selfie")
      setSelectedSubTypeId(selfieSubtype?.subtypeid || "")
    }
  }, [category, subtypeLookup])

  // Helper function to convert file to base64
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })
  }

  // Helper function to get file extension
  const getFileExtension = (filename) => {
    return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase()
  }

  // Helper function to show notifications
  const showNotification = (message, severity = "success") => {
    setNotification({ open: true, message, severity })
  }

  // Helper function to get subtype name by ID (using lookup or category data)
  const getSubtypeNameById = (subtypeId) => {
    console.log("getSubtypeNameById called with:", subtypeId, typeof subtypeId)

    // Convert to string for consistent lookup
    const subtypeIdStr = String(subtypeId)

    // First try the lookup map
    if (subtypeLookup && subtypeLookup[subtypeIdStr]) {
      console.log("Found in lookup:", subtypeLookup[subtypeIdStr].name)
      return subtypeLookup[subtypeIdStr].name
    }

    // Fallback to category subTypes
    if (category && category.subTypes) {
      const subtype = category.subTypes.find((sub) => String(sub.subtypeid) === subtypeIdStr)
      if (subtype) {
        console.log("Found in category:", subtype.name)
        return subtype.name
      }
    }

    console.log("No match found, returning fallback")
    return `Subtype ${subtypeId}`
  }


  // Helper function to get subtype ID by name
  const getSubtypeIdByName = (subtypeName) => {
    if (category && category.subTypes) {
      const subtype = category.subTypes.find((sub) => sub.name === subtypeName)
      return subtype ? subtype.subtypeid : ""
    }
    return ""
  }

  const handleDocumentEdit = (document) => {
    setEditingDocId(document?.id || null)
  }

  const handleDocumentSave = async(pin, updatedDoc) => {
    console.log("pin--------",pin);
    console.log("updatedDoc--------",updatedDoc);
    let dateToSend = updatedDoc;
    dateToSend.userid = selectedUserData?.User?.id;
    dateToSend.agentid = agent?.User?.id;
    dateToSend.pin = pin;
    dateToSend.expiryDate = format(updatedDoc?.expiryDate , 'yyyy-MM-dd');
    dateToSend.issueDate = format(updatedDoc?.issueDate , 'yyyy-MM-dd');

    // const countryObj = states.find(c => c.iso3 === updatedDoc.country);
    // if (countryObj && countryObj.states) {
    //     const stateObj = countryObj.states.find(s => s.id === parseInt(updatedDoc.state));
    //     console.log("handleDocumentSave_stateObj--------",stateObj);
    //     if (stateObj) {
    //         dateToSend.state = stateObj.state_code;
    //     } else {
    //         console.warn(`State with ID ${updatedDoc.state} not found for country ${updatedDoc.country}`);
    //         // Handle missing state: keep original ID or set to empty
    //         dateToSend.state = '';
    //     }
    // } else {
    //     console.warn(`Country ${updatedDoc.country} not found or has no states`);
    // }
    
    const base64String = updatedDoc?.imagedata; // assuming updatedDoc.imageData contains the base64 string

    let extension = null;

    if (base64String && base64String.startsWith('data:')) {
      const matches = base64String.match(/^data:image\/([a-zA-Z0-9+]+);base64,/);
      if (matches && matches[1]) {
        extension = matches[1];
        dateToSend.extension = extension;
      }
    }
    console.log("extension--------",extension);
    console.log("dateToSend--------",dateToSend);

    try {
      const response = await updateKYCInfo(agent?.User?.id, pin, dateToSend?.imagedata, selectedUserData?.User?.id, extension, dateToSend?.country, dateToSend?.subType, dateToSend?.documentImageId, dateToSend?.number, dateToSend?.subTypeDisplay, dateToSend?.dateOfBirth, dateToSend?.expiryDate, dateToSend?.issueDate, dateToSend?.state);

      if(response?.Status == "1") {
        setNotification({ open: true, message: "KYC details added successfully", severity:"success" });

        onDocumentUpdate({
          ...updatedDoc,
          number: updatedDoc.number,
          issueDate: updatedDoc.issueDate ? new Date(updatedDoc.issueDate) : null,
          expiryDate: updatedDoc.expiryDate ? new Date(updatedDoc.expiryDate) : null,
          dateOfBirth: updatedDoc.dateOfBirth ? new Date(updatedDoc.dateOfBirth) : null,
          country: updatedDoc.country,
          state: updatedDoc.state,
          isKycInfoAdded: true,
        });
      }
    } catch (error) {
      setNotification({ open: true, message: "Something went wrong", severity:"error" });
    }

    // onDocumentUpdate(updatedDoc)
    // setEditingDocId(null)
  }

  const handleUploadNew = (subType = "") => {
    // If subType is passed as ID, convert to name
    const subtypeName = typeof subType === "string" && !isNaN(subType) ? getSubtypeNameById(subType) : subType

    setSelectedSubType(subtypeName)

    // Check if it's a selfie upload (by name or category)
    const isSelfieUpload = subtypeName === "Selfie" || category.name === "Selfie Verification" || category.id === "1"

    if (isSelfieUpload) {
      setSelfieDialog(true)
    } else {
      setUploadDialog(true)
    }
  }

  // const handleSelfieUpload = async (file) => {
  //   console.log("Selfie uploaded:", file)
  //   onUploadNew(category.id, "Selfie")
  //   setSelfieDialog(false)
  // }

  const handleSelfieUpload = async (file) => {
    console.log("Selfie uploaded:", file)
    setIsUploading(true)
    
    try {
      const base64Data = await fileToBase64(file)
      const fileExtension = getFileExtension(file.name)
      setSelectedFile(file)
    
      setShowPinPad(true);
      
      // const result = await uploadKYCDocs(selectedUserData?.User?.id, pin, agent?.User?.id, base64Data, fileExtension, selectedSubTypeId, selectedSubType)

      // const result = await uploadSelfie({
      //   file: file,
      //   categoryId: category.id,
      //   userType: userType,
      // })

      // if (result.success) {
      //   showNotification("Selfie uploaded successfully!", "success")
      //   // Call the parent component's callback to refresh the document list
      //   onUploadNew(category.id, "Selfie")
      // } else {
      //   showNotification(`Upload failed: ${result.error}`, "error")
      // }
    } catch (error) {
      console.error("Selfie upload error:", error)
      showNotification("Failed to upload selfie. Please try again.", "error")
    } finally {
      setIsUploading(false)
      setSelfieDialog(false)
    }
  }

  const handleDragOver = (e) => {
    e.preventDefault()
    setIsDragOver(true)
  }

  const handleDragLeave = (e) => {
    e.preventDefault()
    setIsDragOver(false)
  }

  const handleDrop = (e) => {
    e.preventDefault()
    setIsDragOver(false)

    const files = e.dataTransfer.files
    if (files.length > 0) {
      const file = files[0]
      // Check if file type is allowed
      if (file.type.startsWith("image/")) {
        setImageToEdit(file)
        setImageEditorDialog(true)
      } else if (file.type === "application/pdf") {
        setSelectedFile(file)
      } else {
        showNotification("Please upload only image files or PDF documents.", "error")
      }
    }
  }

  const handleFileSelect = (e) => {
    const file = e.target.files[0]
    if (file) {
      // Check if it's an image file
      if (file.type.startsWith("image/")) {
        setImageToEdit(file)
        setImageEditorDialog(true)
      } else {
        // For non-image files (like PDFs), use directly
        setSelectedFile(file)
      }
    }
  }

  const handleImageEditConfirm = (editedFile) => {
    setSelectedFile(editedFile)
    setImageEditorDialog(false)
    setImageToEdit(null)
  }

  const handleImageEditClose = () => {
    setImageEditorDialog(false)
    setImageToEdit(null)
  }

  const handleSubTypeChange = (e) => {
    const selectedId = e.target.value
    const selectedName = getSubtypeNameById(selectedId)

    setSelectedSubTypeId(selectedId)
    setSelectedSubType(selectedName)
  }

  // const handleUploadSubmit = () => {
  //   if (selectedSubType && selectedFile) {
  //     // Here you would typically upload the file to your server
  //     console.log("Uploading file:", selectedFile.name, "Type:", selectedSubType)
  //     onUploadNew(category.id, selectedSubType)
  //     setUploadDialog(false)
  //     setSelectedSubType("")
  //     setSelectedSubTypeId("")
  //     setSelectedFile(null)
  //   }
  // }

  const handleUploadSubmit = async (pin) => {
    if (!selectedSubType || !selectedFile) {
      showNotification("Please select a document type and file.", "error")
      return
    }

    setIsUploading(true)
    setUploadProgress(0)

    try {
      const fileExtension = getFileExtension(selectedFile.name)
      const base64Data = await fileToBase64(selectedFile)

      // Prepare document data
      const documentData = {
        file: selectedFile,
        categoryId: category.id,
        subType: selectedSubType,
        subTypeId: selectedSubTypeId,
        userType: userType,
        base64Data: base64Data, // Base64 string with data URL prefix (data:image/png;base64,...)
        fileExtension: fileExtension, 
        // Add any additional metadata here if needed
        // documentNumber: '',
        // issueDate: '',
        // expiryDate: '',
        // country: '',
        // state: '',
        // dateOfBirth: ''
      }

      console.log("Uploading document:", {
        fileName: selectedFile.name,
        fileSize: selectedFile.size,
        fileType: selectedFile.type,
        fileExtension: fileExtension,
        category: category.name,
        subType: selectedSubType,
        base64Preview: base64Data.substring(0, 100) + "...",
      })

      // Simulate upload progress (you can implement real progress tracking if your API supports it)
      const progressInterval = setInterval(() => {
        setUploadProgress((prev) => {
          if (prev >= 90) {
            clearInterval(progressInterval)
            return prev
          }
          return prev + 10
        })
      }, 200)

      console.log("documentData----------",documentData);
      console.log("agentData----------",agent?.User?.id);
      console.log("pin----------",pin);
      console.log("base64Data----------", base64Data.substring(0, 100) + "...")
      console.log("fileExtension----------", fileExtension)
      console.log("selectedSubTypeId----------", selectedSubTypeId)
      console.log("userType----------", userType)
      
      if (userType === "user") {
        const result = await uploadKYCDocs(selectedUserData?.User?.id, pin, agent?.User?.id, base64Data, fileExtension, selectedSubTypeId, selectedSubType);
        console.log("handleUploadSubmit_result----------", result);
  
        clearInterval(progressInterval)
        setUploadProgress(100)
  
        if (result?.data?.header?.callStatus == "1") {
          showNotification(`${selectedSubType} uploaded successfully!`, "success")
  
          // Store the uploaded image data immediately for display
          const uploadedImageData = base64Data // This is the clean base64 with data URL prefix
  
          // Call the parent component's callback to refresh the document list
          // onUploadNew(category.id, selectedSubType)
          onUploadNew(category.id, selectedSubType, uploadedImageData)
  
          // Close dialog and reset form
          setUploadDialog(false)
          setSelectedSubType("")
          setSelectedSubTypeId("")
          setSelectedFile(null)
        } else {
          showNotification(`Upload failed: ${result.error}`, "error")
        }
      } else {
        // If usertype is merchant
        const result = await uploadMerchantKYCDocs(selectedUserData?.User?.id, pin, agent?.User?.id, base64Data, fileExtension, selectedSubTypeId, selectedSubType);
        console.log("handleUploadSubmit_uploadMerchantKYCDocs_result----------", result);
  
        clearInterval(progressInterval)
        setUploadProgress(100)
  
        if (result?.data?.header?.callStatus == "1") {
          showNotification(`${selectedSubType} uploaded successfully!`, "success")
  
          // Store the uploaded image data immediately for display
          const uploadedImageData = base64Data // This is the clean base64 with data URL prefix
  
          // Call the parent component's callback to refresh the document list
          // onUploadNew(category.id, selectedSubType)
          onUploadNew(category.id, selectedSubType, uploadedImageData)
  
          // Close dialog and reset form
          setUploadDialog(false)
          setSelectedSubType("")
          setSelectedSubTypeId("")
          setSelectedFile(null)
        } else {
          showNotification(`Upload failed: ${result.error}`, "error")
        }
      }
      
    } catch (error) {
      console.error("Document upload error:", error)
      showNotification("Failed to upload document. Please try again.", "error")
    } finally {
      setIsUploading(false)
      setUploadProgress(0)
    }
  }

  const handleDialogClose = () => {
    setUploadDialog(false)
    setSelectedFile(null)
    setIsDragOver(false)
  }

  const handleNotificationClose = () => {
    setNotification({ ...notification, open: false })
  }

  // Group documents by subType
  // const groupedDocuments = documents.reduce((acc, doc) => {
  //   if (!acc[doc.subType]) {
  //     acc[doc.subType] = []
  //   }
  //   acc[doc.subType].push(doc)
  //   return acc
  // }, {})

  const groupedDocuments = documents.reduce((acc, doc) => {
    // Get the subtype name for display
    const subtypeName = getSubtypeNameById(doc.subType)
    // console.log("subtypeName-----------",subtypeName);
    // console.log("acc[subtypeName]-----------",acc);

    if (!acc[subtypeName]) {
      acc[subtypeName] = []
    }
    acc[subtypeName].push(doc)
    return acc
  }, {})

  const getDocumentCounts = () => {
    console.log("getDocumentCounts------------",documents);
    const total = documents.length
    const approved = documents.filter((doc) => doc.status === "approved").length
    const pending = documents.filter((doc) => doc.status === "pending").length
    const rejected = documents.filter((doc) => doc.status === "rejected").length
    const expired = documents.filter((doc) => doc.status === "expired").length

    return { total, approved, pending, rejected, expired }
  }

  const counts = getDocumentCounts();

  const handleConfirm = (event, pin) => {
    let PIN = pin.join('');
    handleUploadSubmit(PIN);
    setShowPinPad(false);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertOpen(false);
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Accordion expanded={expanded} onChange={onAccordionChange}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              width: "100%",
            }}
          >
            <Typography variant="h7">{category.name}</Typography>
            <Box sx={{ display: "flex", gap: 1, ml: "auto" }}>
              <Chip label={`Total: ${counts.total}`} size="small" />
              <Chip label={`Approved: ${counts.approved}`} color="success" size="small" />
              <Chip label={`Pending: ${counts.pending}`} color="warning" size="small" />
              <Chip label={`Rejected: ${counts.rejected}`} color="error" size="small" />
              {counts.expired > 0 && <Chip label={`Expired: ${counts.expired}`} color="error" size="small" />}
            </Box>
          </Box>
        </AccordionSummary>

        <AccordionDetails>
          {/* Upload Section */}
          <Paper sx={{ p: 3, mb: 3, bgcolor: "grey.50" }} className="kyc-upload-doc-container">
            <Typography variant="subtitle1" gutterBottom>
              Upload New Document - {category.name}
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth size="small">
                  <InputLabel>Select Document Type</InputLabel>
                  <Select value={selectedSubTypeId} onChange={handleSubTypeChange} label="Select Document Type">
                    {category.subTypes.map((subType) => (
                      <MenuItem key={subType?.subtypeid} value={subType?.subtypeid}>
                        {subType?.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button
                  variant="contained"
                  startIcon={<UploadIcon />}
                  fullWidth
                  disabled={!selectedSubType}
                  onClick={() => handleUploadNew(selectedSubType)}
                >
                  Upload {selectedSubType || "Document"}
                </Button>
              </Grid>
            </Grid>
          </Paper>

          {/* Documents by SubType */}
          {Object.entries(groupedDocuments).map(([subtypeName, docs]) => (
            <Box key={subtypeName} sx={{ mb: 3 }}>
              <Typography variant="h6" gutterBottom sx={{ color: "primary.main" }}>
                {/* {subType} ({docs.length} document{docs.length !== 1 ? "s" : ""}) */}
                {subtypeName} ({docs.length} document{docs.length !== 1 ? "s" : ""})
              </Typography>

              {isStatusUpdating ? 
                (
                  <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        overflow: "hidden",
                    }}
                  >
                      <CircularProgress />
                  </Box>
                ) : 
                (
                  <>
                    {docs.map((document) => (
                      <DocumentCard
                        key={document.id}
                        // document={document}
                        document={{
                          ...document,
                          // Override subType with the display name for the DocumentCard
                          subTypeDisplay: getSubtypeNameById(document.subType),
                        }}
                        onEdit={handleDocumentEdit}
                        onSave={handleDocumentSave}
                        onMarkExpired={onMarkExpired}
                        onUploadNew={handleUploadNew}
                        onStatusUpdate={onStatusUpdate}
                        countries={countries}
                        states={states}
                        getStatesForCountry={getStatesForCountry}
                        isEditing={editingDocId === document.id}
                        subtypeLookup={subtypeLookup}
                        documentImagesMap={documentImagesMap}
                        setSelectedSubTypeId={setSelectedSubTypeId}
                        getUserKycData={getUserKycData}
                        setIsStatusUpdating={setIsStatusUpdating}
                        activeTab={activeTab}
                      />
                    ))}
                  </>
                )
              }

            </Box>
          ))}

          {/* {documents.length === 0 && (
            <Box sx={{ textAlign: "center", py: 4 }}>
              <Typography variant="body1" color="textSecondary">
                No documents uploaded for {category.name} yet.
              </Typography>
              <Button variant="outlined" startIcon={<UploadIcon />} sx={{ mt: 2 }} onClick={() => handleUploadNew()}>
                Upload First Document
              </Button>
            </Box>
          )} */}
        </AccordionDetails>
      </Accordion>

      {/* Upload Dialog */}
      <Dialog open={uploadDialog} onClose={handleDialogClose} maxWidth="sm" fullWidth>
        <DialogTitle>Upload New {selectedSubType || "Document"}</DialogTitle>
        <DialogContent>
          {!selectedSubType && (
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Select Document Type</InputLabel>
              <Select value={selectedSubTypeId} onChange={handleSubTypeChange} label="Select Document Type">
                {category.subTypes.map((subType) => (
                  <MenuItem key={subType?.subtypeid} value={subType?.subtypeid}>
                    {subType?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {/* Upload Progress */}
          {isUploading && (
            <Box sx={{ mb: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
                <CircularProgress size={20} />
                <Typography variant="body2">
                  {uploadProgress < 90 ? "Processing image..." : "Uploading to server..."}
                </Typography>
              </Box>
              <Box sx={{ width: "100%", bgcolor: "grey.200", borderRadius: 1, height: 8 }}>
                <Box
                  sx={{
                    width: `${uploadProgress}%`,
                    bgcolor: "primary.main",
                    height: "100%",
                    borderRadius: 1,
                    transition: "width 0.3s ease",
                  }}
                />
              </Box>
            </Box>
          )}

          <Box
            sx={{
              p: 3,
              textAlign: "center",
              border: `2px dashed ${isDragOver ? "#1976d2" : "#ccc"}`,
              borderRadius: 1,
              bgcolor: isDragOver ? "action.hover" : "transparent",
              transition: "all 0.2s ease-in-out",
              cursor: isUploading ? "not-allowed" : "pointer",
              opacity: isUploading ? 0.6 : 1,
            }}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onClick={() => !isUploading && document.getElementById("file-input").click()}
          >
            <UploadIcon
              sx={{
                fontSize: 48,
                color: isDragOver ? "primary.main" : "text.secondary",
                mb: 1,
              }}
            />

            {selectedFile ? (
              <Box>
                <Typography variant="body1" gutterBottom color="success.main">
                  File Selected: {selectedFile.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Size: {(selectedFile.size / 1024 / 1024).toFixed(2)} MB
                </Typography>
                {!isUploading && (
                  <Button
                    variant="text"
                    onClick={(e) => {
                      e.stopPropagation()
                      setSelectedFile(null)
                    }}
                    sx={{ mt: 1 }}
                  >
                    Remove File
                  </Button>
                )}
              </Box>
            ) : (
              <Box>
                <Typography variant="body1" gutterBottom>
                  {`Drag and drop your ${selectedSubType || "document"} here`}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Supported formats: JPG, PNG, PDF (Max 10MB)
                </Typography>
              </Box>
            )}

            <input
              id="file-input"
              type="file"
              hidden
              accept="image/*,.pdf"
              onChange={handleFileSelect}
              disabled={isUploading}
            />

            {!selectedFile && !isUploading && (
              <Button variant="outlined" component="span">
                Choose File
              </Button>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} disabled={isUploading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            // onClick={handleUploadSubmit}
            onClick={()=> setShowPinPad(true)}
            disabled={!selectedSubType || !selectedFile || isUploading}
            startIcon={isUploading ? <CircularProgress size={16} /> : <UploadIcon />}
          >
            {isUploading ? "Uploading..." : "Upload"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Selfie Upload Dialog */}
      <SelfieUploadDialog
        open={selfieDialog}
        onClose={() => setSelfieDialog(false)}
        onUpload={handleSelfieUpload}
        isUploading={isUploading}
      />

      {/* Image Editor Dialog */}
      <ImageEditorDialog
        open={imageEditorDialog}
        onClose={handleImageEditClose}
        imageFile={imageToEdit}
        onConfirm={handleImageEditConfirm}
        title={`Edit ${selectedSubType || "Document"} Image`}
      />

      {/* Notification Snackbar */}
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleNotificationClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleNotificationClose} severity={notification.severity} sx={{ width: "100%" }}>
          {notification.message}
        </Alert>
      </Snackbar>

      {showPinPad && 
        <PinPad 
          show={showPinPad} 
          handleConfirm={handleConfirm} 
          onClick={() => setShowPinPad(false)} 
        />
      }
    </Box>
  )
}

export default DocumentCategorySection
